// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@400;500);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nZauDS76vH4SZVENQSgm {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 18px 30px;
  border-radius: 4px;
  background-color: rgba(50, 50, 50, 0.8);
  color: #fff;
  font-size: 20px !important;
  border: 1px solid #3d3d3d;
  cursor: pointer;
  transition: all 0.2s ease;
}
.nZauDS76vH4SZVENQSgm:hover {
  background-color: #6439ab;
}
.nZauDS76vH4SZVENQSgm:active {
  background-color: #382a50;
}
.nZauDS76vH4SZVENQSgm .nKVJBQy_WX2p4dFxO7SD {
  width: 24px;
  height: 24px;
}`, "",{"version":3,"sources":["webpack://./src/editor/components/elements/PanelToggleButton/PanelToggleButton.module.scss","webpack://./src/editor/style/variables.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,kBAAA;EACA,uCAAA;EACA,WCSM;EDRN,0BAAA;EACA,yBAAA;EACA,eAAA;EACA,yBAAA;AAAF;AAEE;EACE,yBCPS;ADOb;AAGE;EACE,yBCLS;ADIb;AAIE;EACE,WAAA;EACA,YAAA;AAFJ","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panelToggleButton": `nZauDS76vH4SZVENQSgm`,
	"icon": `nKVJBQy_WX2p4dFxO7SD`
};
export default ___CSS_LOADER_EXPORT___;
